"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.096 8.904a1.55 1.55 0 1 0-2.192 2.192 1.55 1.55 0 0 0 2.192-2.192m.99-.99a2.95 2.95 0 1 0-4.173 4.171 2.95 2.95 0 0 0 4.174-4.17",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 5.7c-2.333 0-4.42 1.284-5.357 3.237A2.46 2.46 0 0 0 4.4 10c0 .365.082.727.243 1.063C5.58 13.016 7.667 14.3 10 14.3s4.42-1.284 5.357-3.237a2.457 2.457 0 0 0 0-2.126C14.42 6.984 12.333 5.7 10 5.7M3.381 8.33C4.566 5.861 7.165 4.3 10 4.3s5.434 1.56 6.619 4.031a3.856 3.856 0 0 1 0 3.337C15.434 14.14 12.835 15.7 10 15.7s-5.434-1.56-6.619-4.032A3.86 3.86 0 0 1 3 10c0-.577.13-1.146.381-1.669",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EyeShowIcon20.js.map